// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Dztws","grid":"styles_grid__YFQtY","showMoreBtn":"styles_showMoreBtn__lxJE0","dots":"styles_dots__ej7i6"};